import { Component, Output, EventEmitter, OnDestroy, OnInit, AfterViewInit, ChangeDetectorRef, Inject, Renderer2, ViewChild, ElementRef, ViewChildren, QueryList, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../services/layout.service';
import { Subject, Subscription } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { FormControl } from '@angular/forms';
import { LISTITEMS } from '../data/template-search';
import { NavigationEnd, Router } from '@angular/router';
import { User } from 'app/model/user';
import { AuthService } from 'app/shared/auth/auth.service'
import { CommunicationService } from '../services/data/communication-service';
import { NgZone } from '@angular/core';
import { UserService } from '../services/data/user-service';
import { LoginService } from '../services/login/login.service';
import { Roles } from 'app/model/rol';
import { filter, takeUntil } from 'rxjs/operators';
import { CommunicationItem } from 'app/model/communication';


@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  providers: [CommunicationService]
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly REGISTRATION_ROUTE: string = '/pages/registration-tracker'

  currentLang = "en";
  selectedLanguageText = "English";
  selectedLanguageFlag = "./assets/img/flags/us.png";
  toggleClass = "ft-maximize";
  placement = "bottom-right";
  logoUrl = 'assets/img/logo.png';
  menuPosition = 'Side';
  isSmallScreen = false;
  protected innerWidth: any;
  searchOpenClass = "";
  transparentBGClass = "";
  hideSidebar: boolean = true;
  public isCollapsed = true;
  layoutSub: Subscription;
  configSub: Subscription;
  user: User;
  userId: number;
  userName: string;
  userNameApi: string;
  userRole: any;
  initialsName: string;

  private destroy$ = new Subject<void>()

  public isRegistrationRoute: boolean

  public profilePicture: string

  @ViewChild('search') searchElement: ElementRef;
  @ViewChildren('searchResults') searchResults: QueryList<any>;

  @Output()
  toggleHideSidebar = new EventEmitter<Object>();

  @Output()
  seachTextEmpty = new EventEmitter<boolean>();

  listItems = [];
  control = new FormControl();

  public config: any = {};
  serverSideRowData: CommunicationItem[];
  tempData: CommunicationItem[];

  constructor(
    public translate: TranslateService,
    private layoutService: LayoutService,
    private communicationService: CommunicationService,
    private router: Router,
    private loginservice: LoginService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private userService: UserService,
    private ngZone: NgZone
  ) {

    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|es|pt|de/) ? browserLang : "en");
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;

    this.layoutSub = layoutService.toggleSidebar$.subscribe(
      isShow => {
        this.hideSidebar = !isShow;
      });

  }

  ngOnInit(): void {
    this.subscribeRouterEvents()

    this.setUserRole()
    this.userNameApi = sessionStorage.getItem('user')
    this.userId = JSON.parse(sessionStorage.getItem('user')).id;
    this.serverGetCommunication();

    setInterval(() => {
      this.ngZone.run(() => {
        this.serverGetCommunication();
      });
    }, 20000); // cada 20 segs

    this.getUserDetails();

    this.listItems = LISTITEMS;

    this.isSmallScreen = this.innerWidth < 1200
  }

  ngOnDestroy(): void {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }

    this.destroy$.next();
    this.destroy$.complete();
  }

  private subscribeRouterEvents(): void {
    this.isRegistrationRoute = !this.loginservice.isSuper()

    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd), // Solo deja pasar el último evento de ruta (Cuando la navegación termina)
        takeUntil(this.destroy$) // Mantiene la subcripción activa en un Subject y cuando este termina para de escuchar
      )
      .subscribe((e: NavigationEnd) => {
        this.isRegistrationRoute = e.urlAfterRedirects === this.REGISTRATION_ROUTE
      })
  }

  private setUserRole(): void {
    const userRole = this.loginservice.getUser().userRoles[0]?.name ?? 'No Disponible'

    this.userRole = {
      role: userRole,
      class: this.getUserClass(userRole),
      isDefaultUser: userRole === Roles.USER_ROLE
    }
  }

  private getUserClass(role: string): string {
    return (() => {
      switch (role) {
        case Roles.ADMIN_ROLE: return 'bg-light-info'
        case Roles.LEADER_ROLE: return 'bg-light-success'
        case Roles.SUPER_LEADER_ROLE: return 'bg-light-warning'
        default: return ''
      }
    })()
  }

  isDateValid(dateString: string): boolean {
    const endDate = new Date(dateString);
    const today = new Date();
    return endDate >= today || dateString == 'sin caducidad';
  }


  getUserDetails() {
    this.user = this.loginservice.getUser();
    const name = this.user.employee.name + ' ' + this.user.employee.last_name
    const lastName = this.user.employee.last_name
    this.userName = name;
    const names = lastName.split(' ');
    const initials = names.slice(0, 3).map(name => name.charAt(0)).join('');
    this.initialsName = initials;
    this.profilePicture = this.user.profilePicture
  }

  public getUnreadNotificationsCount(): number {
    if (!this.serverSideRowData) return 0 // Devuelve 0 si serverSideRowData no está definido

    const today = new Date()

    const filteredCommunications = this.serverSideRowData.filter(item => {
      const endDate = new Date(item.date_end)

      return !item.has_read
        && (endDate >= today || item.date_end == 'sin caducidad')
        && item.destination !== 'whatsapp'
    })

    return filteredCommunications.length
  }

  private serverGetCommunication(): void {
    this.communicationService.getCommunicationsByUserId(this.userId)
      .subscribe((data) => {
        this.serverSideRowData = data
        this.tempData = this.serverSideRowData
      })
  }

  marcarComoLeido(idComunicacion: number) {
    this.communicationService.marcarComoLeido(idComunicacion)
      .subscribe(
        () => {
          this.router.navigate(['/pages/communication']);
          this.serverGetCommunication()
        },
        error => {
          console.error('Error al marcar como leído:', error);
        }
      );
  }

  marcarComoLeidoTodo() {
    this.communicationService.setAllNonReadCommunicationsUser(this.userId)
      .subscribe(
        () => {
          this.router.navigate(['/pages/communication']);
          this.serverGetCommunication()
        },
        error => {
          console.error('Error al marcar como leído:', error);
        }
      );
  }




  ngAfterViewInit() {
    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();
    })
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = event.target.innerWidth;
    if (this.innerWidth < 1200) {
      this.isSmallScreen = true;
    }
    else {
      this.isSmallScreen = false;
    }
  }

  loadLayout() {

    if (this.config.layout.menuPosition && this.config.layout.menuPosition.toString().trim() != "") {
      this.menuPosition = this.config.layout.menuPosition;
    }

    if (this.config.layout.variant === "Light") {
      this.logoUrl = 'assets/img/logo-dark.png';
    }
    else {
      this.logoUrl = 'assets/img/logo.png';
    }

    if (this.config.layout.variant === "Transparent") {
      this.transparentBGClass = this.config.layout.sidebar.backgroundColor;
    }
    else {
      this.transparentBGClass = "";
    }

  }

  onSearchKey(event: any) {
    if (this.searchResults && this.searchResults.length > 0) {
      this.searchResults.first.host.nativeElement.classList.add('first-active-item');
    }

    if (event.target.value === "") {
      this.seachTextEmpty.emit(true);
    }
    else {
      this.seachTextEmpty.emit(false);
    }
  }

  removeActiveClass() {
    if (this.searchResults && this.searchResults.length > 0) {
      this.searchResults.first.host.nativeElement.classList.remove('first-active-item');
    }
  }

  onEscEvent() {
    this.control.setValue("");
    this.searchOpenClass = '';
    this.seachTextEmpty.emit(true);
  }

  onEnter() {
    if (this.searchResults && this.searchResults.length > 0) {
      let url = this.searchResults.first.url;
      if (url && url != '') {
        this.control.setValue("");
        this.searchOpenClass = '';
        this.router.navigate([url]);
        this.seachTextEmpty.emit(true);
      }
    }
  }

  redirectTo(value) {
    this.router.navigate([value]);
    this.seachTextEmpty.emit(true);
  }


  ChangeLanguage(language: string) {
    this.translate.use(language);

    if (language === 'en') {
      this.selectedLanguageText = "English";
      this.selectedLanguageFlag = "./assets/img/flags/us.png";
    }
    else if (language === 'es') {
      this.selectedLanguageText = "Spanish";
      this.selectedLanguageFlag = "./assets/img/flags/es.png";
    }
    else if (language === 'pt') {
      this.selectedLanguageText = "Portuguese";
      this.selectedLanguageFlag = "./assets/img/flags/pt.png";
    }
    else if (language === 'de') {
      this.selectedLanguageText = "German";
      this.selectedLanguageFlag = "./assets/img/flags/de.png";
    }
  }

  ToggleClass() {
    if (this.toggleClass === "ft-maximize") {
      this.toggleClass = "ft-minimize";
    } else {
      this.toggleClass = "ft-maximize";
    }
  }

  toggleSearchOpenClass(display) {
    this.control.setValue("");
    if (display) {
      this.searchOpenClass = 'open';
      setTimeout(() => {
        this.searchElement.nativeElement.focus();
      }, 0);
    }
    else {
      this.searchOpenClass = '';
    }
    this.seachTextEmpty.emit(true);



  }

  toggleNotificationSidebar() {
    this.layoutService.toggleNotificationSidebar(true);
  }

  toggleSidebar() {
    this.layoutService.toggleSidebarSmallScreen(this.hideSidebar);
  }

  logOut() {
    this.authService.logout();
  }
}
